import { createContext, useContext, useState, ReactNode } from 'react';

interface IRowsExpandedContext {
  isRowsExpanded: boolean,
  setIsRowsExpanded: (isRowsExpanded: boolean) => void,
}

const RowsExpandedContext = createContext<IRowsExpandedContext>({
  isRowsExpanded: false,
  setIsRowsExpanded: () => {},
});

export const RowsExpandedProvider = ({ children }: { children: ReactNode }) => {
  const [isRowsExpanded, setIsRowsExpanded] = useState(false);

  return (
    <RowsExpandedContext.Provider value={ { isRowsExpanded, setIsRowsExpanded } }>
      { children }
    </RowsExpandedContext.Provider>
  );
};

export const useRowsExpandedContext = (): IRowsExpandedContext => useContext(RowsExpandedContext);
